export var CFAR_CONTRACT_TYPE = {
    LEGACY: "Legacy",
    HTS: "Hts",
};
//# sourceMappingURL=cfar.js.map